<template>
  <div
    class="technologyDivParent"
    v-lazy:background-image="{
      src: bg,
    }"
  >
    <title-widge
      :title="title"
      :subTitle="subTitle"
      :titleColor="titleColor"
      :subTitleColor="subTitleColor"
    ></title-widge>
    <div class="divImg">
      <img :src="bgUrl" />
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "rgba(236,37,39,1)",
    },
    subTitleColor: {
      type: String,
      default: "rgba(255,255,255,1)",
    },
    bgUrl: {
      type: String,
      default: "",
    },
    bg: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/technologyWidge.scss";
</style>
